import { useEffect, useRef, useState } from 'react';
import { AttachmentAction, AttachmentAssetType, MediaType, IAttachment } from '../../models/dms/attachment.model';
import { getMediaAttachmentThumbnail } from '../../api/dms/mediaAttachment.api';
import { logTransaction } from '../../common/log';
import { LogType } from '../../models/log.model';
import { IonSpinner } from '@ionic/react';
import { systemPathToBase64Url } from '../../common/util';
import { IonWrapper } from './VehicleAttachment.styles';

interface IComponentProps {
  attachmentType: AttachmentAssetType;
  attachment: IAttachment;
  assetKey: string;
  handleClick: () => void;
}

const VehicleAttachment: React.FC<IComponentProps> = ({ attachment, attachmentType, assetKey, handleClick }) => {
  const [src, setSrc] = useState('assets/image-loading.png');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getThumbnail = async (lineNumber: number) => {
      try {
        setIsLoading(true);

        if (attachment.base64Url) {
          setSrc(attachment.base64Url);
        } else if (attachment.demoUrl) {
          // Demo
          setSrc(attachment.demoUrl);
        } else if (attachment.path) {
          const base64Url = await systemPathToBase64Url(attachment.path, attachment.mimeType || 'image/png');
          base64Url && setSrc(base64Url);
        } else {
          if (attachment.fileName.startsWith('http')) {
            // Attachment is hosted on a URL
            setSrc(attachment.fileName);
          } else {
            // Attachment is hosted on the server
            if (attachment.mediaType === MediaType.Video) {
              // Videos can't be served from the server
              logTransaction(LogType.Warn, "Videos can't be served from the server");
            } else {
              const thumbnail = await getMediaAttachmentThumbnail(attachmentType, assetKey, lineNumber, 100, 100);
              const url = URL.createObjectURL(thumbnail);
              setSrc(url);
            }
          }
        }
      } catch (ex: any) {
        logTransaction(LogType.Error, `Failed to load thumbnail: ${ex.message}`);
      } finally {
        setIsLoading(false);
      }
    };

    getThumbnail(attachment.lineNumber);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handleVideoClick = (event: React.MouseEvent<HTMLVideoElement>) => {
  //   event.preventDefault(); // Prevent default interaction if necessary
  //   if (videoRef.current) {
  //     videoRef.current.pause(); // Pause the video
  //   }
  //   handleClick();
  // };

  const videoRef = useRef<HTMLVideoElement | null>(null);

  const handleError = () => {
    setSrc('assets/broken-load.png');
  };

  return (
    <IonWrapper>
      {attachment.action === AttachmentAction.Add ? (
        <div className="img-container">
          <img src={src} onClick={() => {}} onError={() => handleError()} alt="Media Attachment" />
          <IonSpinner name="lines" color="secondary" />
        </div>
      ) : isLoading ? (
        <div className="img-container">
          <img src="assets/image-loading.png" onError={() => handleError()} alt="Media Attachment" />
          <IonSpinner name="lines" color="secondary" />
        </div>
      ) : (
        <div className="img-container" onClick={() => handleClick()}>
          {attachment.mediaType === MediaType.Video ? <video ref={videoRef} src={`${src}#t=0.01`} preload="metadata" onClick={() => {}} /> : <img src={src} onClick={() => {}} onError={() => handleError()} alt="Media Attachment" />}
        </div>
      )}
    </IonWrapper>
  );
};

export default VehicleAttachment;
